// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gap-1[data-v-b27d7762]{gap:4px}.gap-2[data-v-b27d7762]{gap:8px}.gap-3[data-v-b27d7762]{gap:12px}", ""]);
// Exports
module.exports = exports;
